// ─── De qué archivo es el transcript de un clip ─────────────────────────────
// El transcript de un clip (`clip.transcript`) se guarda en el clip y sus
// tiempos son SEGUNDOS DEL ARCHIVO (`clip.storagePath`). Varias cosas cambian
// el archivo de un clip sin pasar por acá: "Editar clip" lo reemplaza por el
// tramo recortado (que empieza en 0), traducir lo reemplaza por otra voz,
// borrar un objeto o pasar a 1080p por una copia con el mismo audio. Si el
// transcript viejo se queda, "Corregir voz" muestra las oraciones de OTRO
// tramo (bug 2026-09-28: un clip recortado y editado mostraba el texto del
// principio del archivo original).
//
// La regla: el transcript lleva el `storagePath` del archivo que se transcribió,
// y sólo vale mientras el clip siga apuntando a ese archivo. Sin marca (un
// transcript de antes de esta regla) vale como siempre.
// Ver ADR-2026-09-28-el-transcript-sabe-de-que-archivo-es.

export interface TranscriptMarcado {
  /** El archivo (`storagePath`) al que corresponden los tiempos. */
  storagePath?: string;
}

/** El transcript con la marca del archivo al que pertenece. */
export function marcarTranscript<T extends object>(
  transcript: T,
  storagePath: string | undefined,
): T & TranscriptMarcado {
  return storagePath ? { ...transcript, storagePath } : transcript;
}

/**
 * El transcript del clip si todavía corresponde a su archivo; `undefined` si el
 * clip cambió de archivo desde que se transcribió (hay que transcribir de nuevo)
 * o si no tiene.
 */
export function transcriptVigente<T extends object>(clip: {
  storagePath?: string;
  transcript?: T;
}): T | undefined {
  const t = clip.transcript;
  if (!t) return undefined;
  const marca = (t as TranscriptMarcado).storagePath;
  if (marca && marca !== clip.storagePath) return undefined;
  return t;
}
